import type { SVGProps } from 'react';
const SvgIconPlus = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}>
    <path
      fill="currentColor"
      d="M8.75 2.75a.75.75 0 0 0-1.5 0L7 7l-4.25.25a.75.75 0 0 0 0 1.5L7 9l.25 4.25a.75.75 0 0 0 1.5 0L9 9l4.25-.25a.75.75 0 0 0 0-1.5L9 7z"
    />
  </svg>
);
export default SvgIconPlus;
